import { render, staticRenderFns } from "./CambioAsientoPasoMapaGeneral.vue?vue&type=template&id=443f21ac"
import script from "./CambioAsientoPasoMapaGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./CambioAsientoPasoMapaGeneral.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports